import { trackGoal } from './trackGoal'
import { getOAuth2TokensFromStorage, isTokenExpired } from './oauth2Tokens'

export type SessionClearReason =
  | 'interceptor_refresh_fail'
  | 'loadSelf_refresh_fail'
  | 'loadSelf_retry_401'
  | 'loadSelf_other_401'
  | 'refresh_endpoint_401'
  | 'explicit_signout'
  | 'unknown'

type TelemetryPayload = Record<string, string | number | boolean | null | undefined>

let refreshInFlight = false
let concurrent401WhileRefresh = 0
let last401Urls: string[] = []

export function setRefreshInFlight(value: boolean): void {
  refreshInFlight = value
  if (!value) {
    concurrent401WhileRefresh = 0
    last401Urls = []
  }
}

export function isRefreshInFlight(): boolean {
  return refreshInFlight
}

export function note401DuringRefresh(url?: string): void {
  if (!refreshInFlight) {
    return
  }
  concurrent401WhileRefresh += 1
  if (url) {
    last401Urls = [...last401Urls.slice(-4), url]
  }
}

function baseAuthContext(): TelemetryPayload {
  const tokens = getOAuth2TokensFromStorage()
  return {
    refresh_in_flight: refreshInFlight,
    had_refresh_token: Boolean(tokens?.refresh_token),
    access_expired: tokens?.access_token ? isTokenExpired() : null,
    concurrent_401_count: concurrent401WhileRefresh,
    recent_401_urls: last401Urls.join(' | ') || undefined,
  }
}

export function trackAuthSessionEvent(event: string, params: TelemetryPayload = {}): void {
  const payload = {
    ...baseAuthContext(),
    ...params,
    ts: new Date().toISOString(),
  }
  console.warn(`[auth-session] ${event}`, payload)
  try {
    trackGoal(event, payload)
  } catch (error) {
    console.warn('[auth-session] trackGoal failed', error)
  }
}

export function trackSessionCleared(
  reason: SessionClearReason,
  params: TelemetryPayload = {},
): void {
  trackAuthSessionEvent('session_cleared', { reason, ...params })
}

export function isAccessTokenExpiredErrorText(errorText: unknown): boolean {
  const text =
    typeof errorText === 'string'
      ? errorText
      : errorText == null
        ? ''
        : String(errorText)
  return text.includes('Токен истек, требуется обновление')
}

/** Нужен ли retry 401 через refresh, чтобы toast не всплыл при живой сессии. */
export function shouldRetry401WithRefresh(isOAuth2: boolean, errorText: unknown): boolean {
  return isOAuth2 || isAccessTokenExpiredErrorText(errorText)
}
